<template>
  <div class="calculator">
    <multiform />
  </div>
</template>

<script>
import multiform from './components/multiform.vue';

export default {
  name: 'VueCalculateMyseed',
  components: {
    multiform,
  },
};
</script>

<style lang="css" scoped></style>
